import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const session_invitesScreenModule = defineScreen({
  app: "coaching",
  screen_id: "session-invites",
  path: "/sessions/:session_id/invites",
  params: ["session_id"],
  heading: { text: "Invite operations", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "page.load" }
  ],
  recipe: "Page-1",
  data: { seedNeeds: ["readonly-walk-session"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/session-invites.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default session_invitesScreenModule;
